import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconMoon, IconSun } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { saveUserSetting } from '@/reducers/userSettings/userSettings.actions'
import { DARK_MODE, useTheme } from '@/utils/hooks/useTheme'

export const DarkModeToggle = ({ collapsed = false }) => {
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.userSettings.loading)
  const saving = useSelector((state) => state.userSettings.saving)
  const theme = useTheme()
  const isDark = theme === 'dark'

  const label = isDark ? 'Light mode' : 'Dark mode'

  const handleToggle = () => {
    dispatch(saveUserSetting(DARK_MODE, !isDark))
  }

  return (
    <Button
      basic
      small
      square
      onClick={handleToggle}
      disabled={loading || saving}
      data-testid="dark-mode-toggle"
      aria-label={label}
      tooltip={label}
      tooltipProps={{ placement: collapsed ? 'right' : 'top' }}
    >
      {isDark ? <IconSun /> : <IconMoon />}
    </Button>
  )
}
